export const initialState = {
    students: 23,
    groups: 34,
    selectedCollege: 'Electrical and Mechanical Engineering',
    selectedDepartment: 'Software Engineering',
    selectedSemester: '2',
    selectedTerm: '2022',
    currentTerm: [],
    semesters: [],
    terms: ['2022', '2021', '2020', '2019'],
    overload: 23,
    underload: 43,
    neutral: 11,
    fullTime: 34,
    partTime: 22,
    staffLoad: [0,12,12,15],
}